import cn from 'classnames';
import Link from 'next/link';
import {
  BUTTON_BASE,
  BUTTON_CLASS,
  BUTTON_COLORS,
  type ButtonSize,
} from '@src/components/atoms/buttons/button';

/**
 * The `Button` atom's appearance on a real anchor.
 *
 * The interactive pages navigate with `router.push` inside an `onClick`, which
 * a crawler cannot follow and a person cannot middle-click. Server-rendered
 * pages use this instead, and pull their classes from the atom so the two
 * stay identical.
 */
export default function LinkButton({
  href,
  children,
  variant = 'neutral',
  buttonSize = 'xxsmall',
  className,
  disabled = false,
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'neutral' | 'gray';
  buttonSize?: ButtonSize;
  className?: string;
  disabled?: boolean;
}) {
  const classes = cn(
    BUTTON_BASE,
    BUTTON_COLORS[variant],
    BUTTON_CLASS[buttonSize],
    className
  );

  if (disabled) {
    return (
      <span
        aria-disabled
        className={cn(classes, 'pointer-events-none opacity-40')}
      >
        {children}
      </span>
    );
  }

  return (
    <Link href={href} className={classes}>
      {children}
    </Link>
  );
}
